'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectBoxLabelTextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

/** Prop Receivers */
var spacingProps = function spacingProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var marginRight = (0, _reactackleCore.getValueString)(theme.reactackle.components.selectBox.label.labelTooltipSpacing);

  return '\n    margin-right: ' + marginRight + ';\n  ';
};

/** STYLES */
var SelectBoxLabelTextStyled = exports.SelectBoxLabelTextStyled = _styledComponents2.default.span.withConfig({
  displayName: 'SelectBoxLabelTextStyled'
})(['', ';', ';'], /* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */'', spacingProps);

SelectBoxLabelTextStyled.propTypes = propTypes;
SelectBoxLabelTextStyled.displayName = 'SelectBoxLabelTextStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-selectbox/dist/styles/SelectBoxLabelTextStyled.js
// module id = 228
// module chunks = 0